<div class="hidden md:flex text-gray-900 border-4 border-gray-200 bg-gray-100 px-4 py-6 flex-col justify-center items-center gap-8 h-full">
  <div class="flex flex-col gap-2 justify-center items-center">
    <img src="/icons/photo.svg" class="h-6 w-6">
    <div class="font-bold text-xl px-6 text-center">{{getText().splash.side.title}}</div>
  </div>
  <qr-code [value]="linkQR" size="150" errorCorrectionLevel="M" />
  <div class="text-xs">{{getText().splash.side.content}}</div>
</div>